import React from 'react';

const PreventSSR = ({ children }) => {
    // prevents component to be rendered on server-side
    return <div>{typeof window === 'undefined' ? null : children}</div>;
};

export default PreventSSR;
